import { ProductActions } from '../../../../actions/ProductActions/ProductActions';
export var getDefaultProduct = function (_a) {
    var context = _a.context, origin = _a.origin;
    return function (options) {
        return new ProductActions({ siteStore: context.siteStore, origin: origin }).fetchDefaultProduct(options);
    };
};
//# sourceMappingURL=getDefaultProduct.js.map